var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn" },
    [
      _vm.loading
        ? _c(
            "div",
            { staticClass: "loading" },
            [
              _c("square-loader", {
                attrs: { loading: true, color: "#26A65B", size: "50px" }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-card",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "12", sm: "7" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: _vm.$t("outlet"),
                        "label-cols": 2,
                        "label-class": "text-right",
                        horizontal: true
                      }
                    },
                    [
                      _c("v-select", {
                        attrs: {
                          options: _vm.outlets[_vm.$session.get("lang")]
                        },
                        model: {
                          value: _vm.outlet,
                          callback: function($$v) {
                            _vm.outlet = $$v
                          },
                          expression: "outlet"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "12", sm: "3" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: _vm.$t("date"),
                        "label-cols": 2,
                        "label-class": "text-right",
                        horizontal: true
                      }
                    },
                    [
                      _c("date-range-picker", {
                        attrs: {
                          startDate: _vm.start_date,
                          endDate: _vm.end_date,
                          "locale-data": _vm.locale
                        },
                        on: { update: _vm.updateDate }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "12", sm: "2" } },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "success" },
                      on: { click: _vm.refresh }
                    },
                    [
                      _c("i", { staticClass: "fa fa-search" }),
                      _vm._v(" " + _vm._s(_vm.$t("search")))
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("b-col", { attrs: { cols: "12", sm: "12" } }, [
                _c(
                  "div",
                  { staticClass: "process-container bg-secondary" },
                  [
                    _c("div", {
                      staticClass: "current bg-primary",
                      style: "width: " + _vm.current + "%"
                    }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "target bg-danger",
                      style: "margin-left: " + _vm.target + "%",
                      attrs: { id: "target" }
                    }),
                    _vm._v(" "),
                    _c(
                      "b-tooltip",
                      {
                        attrs: {
                          show: _vm.show_target,
                          target: "target",
                          placement: "bottom"
                        },
                        on: {
                          "update:show": function($event) {
                            _vm.show_target = $event
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm._f("numeral")(_vm.target_sales, "0,0")) +
                            "\n          "
                        )
                      ]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { sm: "6", lg: "6" } },
            [
              _c(
                "b-card",
                { staticClass: "bg-primary", attrs: { "no-body": "" } },
                [
                  _c("b-card-body", { staticClass: "pb-0" }, [
                    _c("div", { staticClass: "float-right font-3xl" }, [
                      _c("i", { staticClass: "fa fa-money" })
                    ]),
                    _vm._v(" "),
                    _c("h4", { staticClass: "mb-0" }, [
                      _vm._v(_vm._s(_vm._f("numeral")(_vm.total_sales, "0,0")))
                    ]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.$t("total_sale")))])
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { sm: "6", lg: "6" } },
            [
              _c(
                "b-card",
                { staticClass: "bg-primary", attrs: { "no-body": "" } },
                [
                  _c("b-card-body", { staticClass: "pb-0" }, [
                    _c("div", { staticClass: "float-right font-3xl" }, [
                      _c("i", { staticClass: "fa fa-shopping-basket" })
                    ]),
                    _vm._v(" "),
                    _c("h4", { staticClass: "mb-0" }, [
                      _vm._v(_vm._s(_vm._f("numeral")(_vm.total_cheque, "0,0")))
                    ]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.$t("total_cheque")))])
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { sm: "6", lg: "6" } },
            [
              _c(
                "b-card",
                { staticClass: "bg-primary", attrs: { "no-body": "" } },
                [
                  _c("b-card-body", { staticClass: "pb-0" }, [
                    _c("div", { staticClass: "float-right font-3xl" }, [
                      _c("i", { staticClass: "fa fa-bar-chart" })
                    ]),
                    _vm._v(" "),
                    _c("h4", { staticClass: "mb-0" }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("numeral")(
                            _vm.total_sales / _vm.total_cheque,
                            "0,0.00"
                          )
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.$t("average_cheque")))])
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { sm: "6", lg: "6" } },
            [
              _c(
                "b-card",
                { staticClass: "bg-primary", attrs: { "no-body": "" } },
                [
                  _c("b-card-body", { staticClass: "pb-0" }, [
                    _c("div", { staticClass: "float-right font-3xl" }, [
                      _c("i", { staticClass: "fa fa-bullhorn" })
                    ]),
                    _vm._v(" "),
                    _c("h4", { staticClass: "mb-0" }, [
                      _vm._v(_vm._s(_vm._f("numeral")(_vm.sos, "0,0.00")))
                    ]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.$t("sos")))])
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("b-col", { attrs: { sm: "12" } }, [_c("hr")]),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { sm: "12", lg: "6" } },
            [
              _c("pie", {
                attrs: {
                  labels: _vm.sale_by_channel_labels[_vm.$session.get("lang")],
                  datasets: _vm.sale_by_channel_datasets
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "full-width text-center bg-gray-100 chart-title"
                },
                [_c("h2", [_vm._v(_vm._s(_vm.$t("sales_by_channel")))])]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { sm: "12", lg: "6" } },
            [
              _c("pie", {
                attrs: {
                  labels: _vm.sale_by_type_labels[_vm.$session.get("lang")],
                  datasets: _vm.sale_by_type_datasets
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "full-width text-center bg-gray-100 chart-title"
                },
                [_c("h2", [_vm._v(_vm._s(_vm.$t("sales_by_type")))])]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("b-col", { attrs: { sm: "12" } }, [_c("hr")]),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { sm: "12", lg: "6" } },
            [
              _c("pie", {
                attrs: {
                  labels:
                    _vm.cheque_by_channel_labels[_vm.$session.get("lang")],
                  datasets: _vm.cheque_by_channel_datasets
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "full-width text-center bg-gray-100 chart-title"
                },
                [_c("h2", [_vm._v(_vm._s(_vm.$t("cheque_by_channel")))])]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { sm: "12", lg: "6" } },
            [
              _c("pie", {
                attrs: {
                  labels: _vm.cheque_by_type_labels[_vm.$session.get("lang")],
                  datasets: _vm.cheque_by_type_datasets
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "full-width text-center bg-gray-100 chart-title"
                },
                [_c("h2", [_vm._v(_vm._s(_vm.$t("cheque_by_type")))])]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7af4eb22", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7af4eb22","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/SalesHistory.vue
// module id = 1288
// module chunks = 0